import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from "../../../app/ui/modal/v4/v4";

import CreateExisting from './select-exisiting/select-existing';
import CreateNew from './create-tag/create-tag';
import RemoveTagExisting from "./remove-exisiting/remove-exisiting";

const CUR_VALUE_NEW = 'new';
const CUR_VALUE_EXISTING = 'existing';
const CUR_VALUE_REMOVE = 'remove';

class ModalTag extends ModalV4 {

    static propTypes = {
        params: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            curValue: props.params.removeOnly ? CUR_VALUE_REMOVE : props.params.newOnly ? CUR_VALUE_NEW : CUR_VALUE_EXISTING,
            statusId: props.params.statusId ? props.params.statusId : null
        }
    }

    onClickNew = () => {this.setState({curValue:CUR_VALUE_NEW})}
    onAddExisting = (id) => {this.props.params.onSubmit({statusId:id})}
    onClickBack = () => {this.setState({curValue:CUR_VALUE_EXISTING})}

    onAddTag = (tagId) => {
        const requestBulk = gd.api.BulkActions.addTag(this.props.params.tasks.map(task=>task.id), tagId);

        requestBulk.done(()=>{
            if (this.props.params.callback) this.props.params.callback(tagId);
        });
    }

    onRemoveTag = (tagId) => {
        const requestBulk = gd.api.BulkActions.removeTag(this.props.params.tasks.map(task=>task.id), tagId);

        requestBulk.done(()=>{
            if (this.props.params.callback) this.props.params.callback(tagId);
        });
    }

    render() {
        switch (this.state.curValue){
            case CUR_VALUE_EXISTING:
                return <CreateExisting params={this.props.params}
                                       onTagSelect={this.onAddTag}
                                       onClickNew={this.onClickNew}
                                       onClick={this.stopPropagation}
                                       onCloseClick={this.closeModal}/>;

            case CUR_VALUE_NEW:
                return <CreateNew statusId={this.state.statusId}
                                  params={this.props.params}
                                  onTagSelect={this.onAddTag}
                                  onClickBack={this.onClickBack}
                                  onClick={this.stopPropagation}
                                  onCloseClick={this.closeModal}/>;

            case CUR_VALUE_REMOVE:
                return <RemoveTagExisting params={this.props.params}
                                          onRemoveTag={this.onRemoveTag}
                                          onClick={this.stopPropagation}
                                          onCloseClick={this.closeModal}/>;
        }
    }
}

module.exports = ModalTag;